import { useState, useEffect } from "react";
import logo from './assets/infraLogo.jpg';
import { useNavigate } from "react-router-dom";

const modules = [
  {
    title: "Inventory Management",
    subtitle: "Stores - Purchase - Vendor",
    color: "from-violet-600 to-purple-700",
    hoverColor: "hover:from-violet-500 hover:to-purple-600",
    icon: "📦",
    route: "/infra-dashboard",
    description: "Manage stock, purchases, and vendor relationships"
  },
  {
    title: "Vehicle and Fleet Management",
    color: "from-emerald-600 to-teal-700",
    hoverColor: "hover:from-emerald-500 hover:to-teal-600",
    icon: "🚗",
    route: "/Vehicle/VehicleHome",
    description: "Track and manage your vehicle fleet"
  },
  {
    title: "Payroll Management",
    color: "from-amber-600 to-orange-700",
    hoverColor: "hover:from-amber-500 hover:to-orange-600",
    icon: "💰",
    route:"/PayRoll/BonusPercentage",
    description: "Employee payroll and compensation"
  },
  {
    title: "Asset Management",
    color: "from-blue-600 to-cyan-700",
    hoverColor: "hover:from-blue-500 hover:to-cyan-600",
    icon: "📊",
    route:"/Asset/AssetHome",
    description: "Monitor and control business assets"
  },
  {
    title: "GST Module with Inventory",
    color: "from-indigo-600 to-blue-700",
    hoverColor: "hover:from-indigo-500 hover:to-blue-600",
    icon: "🧾",
    description: "Tax management integrated with inventory"
  },
  {
    title: "Project Management (Pre-order)",
    color: "from-sky-600 to-blue-700",
    hoverColor: "hover:from-sky-500 hover:to-blue-600",
    icon: "📋",
    route:"/OrderManagement/PreOrder-DashboardReport",
    description: "Pre-order project planning and execution"
  },
  {
    title: "Project Management (Post-order)",
    color: "from-orange-600 to-red-700",
    hoverColor: "hover:from-orange-500 hover:to-red-600",
    icon: "📈",
    route:"/OrderManagement/PostOrder-DashboardReport",
    description: "Post-order project management"
  },
  {
    title: "Production Management",
    color: "from-teal-600 to-cyan-700",
    hoverColor: "hover:from-teal-500 hover:to-cyan-600",
    icon: "🏭",
    route:"/TarMixing/Tar_BOM_Listing",
    description: "Manufacturing and production oversight"
  },
  {
    title: "Payments and Vouchers",
    color: "from-rose-600 to-pink-700",
    hoverColor: "hover:from-rose-500 hover:to-pink-600",
    icon: "💳",
    route:"/PaymentVouchers/LabourCharges",
    description: "Financial transactions and vouchers"
  },
  {
    title: "Sales Module",
    color: "from-cyan-600 to-blue-700",
    hoverColor: "hover:from-cyan-500 hover:to-blue-600",
    icon: "📊",
    route:"/Sales/Dashboard",
    description: "Sales tracking and customer management"
  },
  {
    title: "Help File",
    color: "from-slate-600 to-gray-700",
    hoverColor: "hover:from-slate-500 hover:to-gray-600",
    icon: "❓",
    description: "Documentation and support resources"
  },
];

const themes = [
  { name: "Corporate Blue", value: "from-slate-900 via-blue-900 to-indigo-900", accent: "blue" },
  { name: "Professional Dark", value: "from-gray-900 via-slate-800 to-gray-900", accent: "gray" },
  { name: "Executive Green", value: "from-gray-900 via-emerald-900 to-teal-900", accent: "emerald" },
  { name: "Modern Purple", value: "from-slate-900 via-purple-900 to-violet-900", accent: "purple" },
];

export default function HomePage() {
  const navigate=useNavigate();
  const [currentTheme, setCurrentTheme] = useState(themes[0]);
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    sessionStorage.setItem("branchid", "8");
    sessionStorage.setItem("branchname", "HO");
    
    // Add loading animation
    setTimeout(() => setIsLoaded(true), 100);
  }, []);

 const handleCardClick = (route) => {
    if (route) {
      navigate(route);
    }
  };

  const handleThemeChange = (theme) => {
    setCurrentTheme(theme);
  };

  return (
    <div className={`min-h-screen bg-gradient-to-br ${currentTheme.value} transition-all duration-700 relative overflow-hidden`}>
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0 bg-grid-white/[0.02] bg-[size:50px_50px]" />
      </div>
      
      {/* Header */}
      <div className="relative z-10 px-8 pt-8">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col lg:flex-row justify-between items-start lg:items-center mb-12">
            <div className="mb-6 lg:mb-0">
              {/* Logo and Title */}
              <div className="flex items-center gap-4 mb-4">
                {/* Construction Logo */}
                <div className="w-16 h-16 rounded-2xl overflow-hidden shadow-2xl bg-white/10 backdrop-blur-sm border border-white/20 flex items-center justify-center">
                  <img 
                    src={logo} 
                    alt="Infraconsoft Logo" 
                    className="w-14 h-14 object-contain"
                  />
                </div>
                <div>
                  <h1 className="text-white text-5xl font-bold tracking-tight">
                    Infraconsoft
                  </h1>
                  <p className="text-white/70 text-lg font-medium">
                    Enterprise Resource Planning • Branch: HO
                  </p>
                </div>
              </div>
              
              {/* Construction Quote */}
          
            </div>
            
            <div className="flex flex-col sm:flex-row gap-4 items-start sm:items-center">
              <div className="text-white/60 text-sm font-medium">Theme:</div>
              <div className="flex gap-2">
                {themes.map((theme, idx) => (
                  <button
                    key={idx}
                    onClick={() => handleThemeChange(theme)}
                    className={`px-4 py-2 rounded-xl text-sm font-semibold transition-all duration-300 backdrop-blur-sm border ${
                      currentTheme.name === theme.name
                        ? 'bg-white/20 text-white border-white/40 shadow-lg'
                        : 'bg-white/5 text-white/70 border-white/20 hover:bg-white/10 hover:text-white'
                    }`}
                  >
                    {theme.name}
                  </button>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Dashboard Grid */}
      <div className="relative z-10 px-8 pb-12">
        <div className="max-w-7xl mx-auto">
          <div className={`grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-8 ${isLoaded ? 'animate-fadeIn' : 'opacity-0'}`}>
            {modules.map((module, idx) => (
              <div
                key={idx}
               onClick={() => handleCardClick(module.route)}
                className={`group relative bg-gradient-to-br ${module.color} ${module.hoverColor} rounded-3xl text-white shadow-2xl p-8 cursor-pointer transition-all duration-500 hover:shadow-3xl hover:scale-[1.02] backdrop-blur-sm border border-white/10`}
                style={{
                  animationDelay: `${idx * 50}ms`,
                }}
              >
                {/* Card Background Overlay */}
                <div className="absolute inset-0 bg-gradient-to-br from-white/10 to-transparent rounded-3xl opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                
                {/* Content */}
                <div className="relative z-10">
                  {/* Icon */}
                  <div className="text-6xl mb-6 transform group-hover:scale-110 transition-transform duration-300">
                    {module.icon}
                  </div>
                  
                  {/* Title */}
                  <h3 className="text-2xl font-bold mb-3 leading-tight">
                    {module.title}
                  </h3>
                  
                  {/* Subtitle */}
                  {module.subtitle && (
                    <p className="text-white/90 font-medium mb-3 text-lg">
                      {module.subtitle}
                    </p>
                  )}
                  
                  {/* Description */}
                  <p className="text-white/70 text-sm leading-relaxed mb-6">
                    {module.description}
                  </p>
                  
                  {/* Action Indicator */}
                  <div className="flex items-center justify-between">
                    <div className="w-12 h-1 bg-white/30 rounded-full group-hover:bg-white/60 transition-colors duration-300" />
                    {module.route && (
                      <div className="text-white/60 group-hover:text-white transition-colors duration-300">
                        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                        </svg>
                      </div>
                    )}
                  </div>
                </div>
                
                {/* Glow Effect */}
                <div className="absolute -inset-1 bg-gradient-to-r from-white/20 to-white/10 rounded-3xl opacity-0 group-hover:opacity-100 transition-opacity duration-500 blur-xl -z-10" />
              </div>
            ))}
          </div>
        </div>
      </div>
      
      {/* Footer */}
      <div className="relative z-10 px-8 pb-8">
        <div className="max-w-7xl mx-auto">
          <div className="text-center text-white/50 text-sm">
            <p>© REGISTERED PRODUCT OF NISSI INFOTECH PRIVATE LIMITED</p>
          </div>
        </div>
      </div>

      <style jsx>{`
        @keyframes fadeIn {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        
        .animate-fadeIn {
          animation: fadeIn 0.6s ease-out forwards;
        }
        
        .bg-grid-white\\/\\[0\\.02\\] {
          background-image: radial-gradient(circle, white 1px, transparent 1px);
        }
        
        .shadow-3xl {
          box-shadow: 0 35px 60px -12px rgba(0, 0, 0, 0.5);
        }
      `}</style>
    </div>
  );
}